export const TOOK_RF_QUIZ = 'TOOK_RF_QUIZ';
export const TOOK_LM_QUIZ = 'TOOK_LM_QUIZ';
export const TOOK_MM_QUIZ = 'TOOK_MM_QUIZ';
export const SET_WHOLE_TRACKER = 'SET_WHOLE_TRACKER';
